module.exports = __webpack_public_path__ + "static/media/tray-manual-import2.9c68396d.png";